<template>
  <div>
    <p
      v-if="note"
      class="text-body-2 text-medium-emphasis mb-4"
      data-testid="banner-copy-note"
    >
      {{ note }}
    </p>
    <SoTextField
      :model-value="modelValue.title"
      label="Title"
      :maxlength="FIELD_MAX_LENGTH.title"
      :error="errors.title"
      data-testid="banner-copy-title"
      @update:model-value="update('title', $event)"
    />
    <SoTextarea
      :model-value="modelValue.subtitle"
      label="Subtitle"
      :max-length="FIELD_MAX_LENGTH.subtitle"
      counter
      :error="errors.subtitle"
      class="mt-2"
      data-testid="banner-copy-subtitle"
      @update:model-value="update('subtitle', $event)"
    />
    <SoTextField
      :model-value="modelValue.buttonText"
      label="Button text"
      :maxlength="FIELD_MAX_LENGTH.buttonText"
      :error="errors.buttonText"
      class="mt-2"
      data-testid="banner-copy-button-text"
      @update:model-value="update('buttonText', $event)"
    />
    <SoTextField
      :model-value="modelValue.buttonLink"
      label="Button link"
      :maxlength="FIELD_MAX_LENGTH.buttonLink"
      :error="errors.buttonLink"
      class="mt-2"
      data-testid="banner-copy-button-link"
      @update:model-value="update('buttonLink', $event)"
    />
    <SoSelect
      :model-value="modelValue.illustrationName"
      :items="illustrations"
      type="simple"
      label="Illustration"
      :error="errors.illustrationName"
      class="mt-2"
      data-testid="banner-copy-illustration"
      @update:model-value="update('illustrationName', $event)"
    />
    <MarketingBannerPreview :copy="modelValue" class="mt-4" />
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoTextField from "@/components/formControls/SoTextField.vue"
  import SoTextarea from "@/components/formControls/SoTextarea.vue"
  import SoSelect from "@/components/formControls/SoSelect.vue"
  import { FIELD_MAX_LENGTH } from "@/models/alertsBanners/marketingBannerConfig"
  import {
    BannerCopyErrors,
    BannerCopyField,
    IBannerCopy,
  } from "@/views/admin/marketingBanners/marketingBannerCopy"
  import { ILLUSTRATION_NAMES } from "@/views/admin/marketingBanners/marketingBannerIllustrations"
  import MarketingBannerPreview from "./MarketingBannerPreview.vue"

  export default defineComponent({
    components: { SoTextField, SoTextarea, SoSelect, MarketingBannerPreview },
    props: {
      modelValue: {
        type: Object as PropType<IBannerCopy>,
        required: true,
      },
      errors: {
        type: Object as PropType<BannerCopyErrors>,
        default: () => ({}),
      },
      note: {
        type: String,
        default: undefined,
      },
    },
    emits: ["update:modelValue"],
    data() {
      return { FIELD_MAX_LENGTH }
    },
    computed: {
      illustrations(): string[] {
        return ILLUSTRATION_NAMES.includes(this.modelValue.illustrationName)
          ? [...ILLUSTRATION_NAMES]
          : [this.modelValue.illustrationName, ...ILLUSTRATION_NAMES]
      },
    },
    methods: {
      update(field: BannerCopyField, value: unknown) {
        this.$emit("update:modelValue", {
          ...this.modelValue,
          [field]: typeof value === "string" ? value : "",
        })
      },
    },
  })
</script>
